<template>
  <code class="select-all border border-border bg-white px-1.5 py-0.5 font-normal"><slot /></code>
</template>
<style scoped>
code {
  font-size: calc(100% / 1.14);
}
</style>
